/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Stage_StructureInputs */

const en_directory_submit_enrich_stage_structure = /** @type {(inputs: Directory_Submit_Enrich_Stage_StructureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product structure`)
};

const zh_directory_submit_enrich_stage_structure = /** @type {(inputs: Directory_Submit_Enrich_Stage_StructureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提取产品结构`)
};

/**
* | output |
* | --- |
* | "Product structure" |
*
* @param {Directory_Submit_Enrich_Stage_StructureInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_stage_structure = /** @type {((inputs?: Directory_Submit_Enrich_Stage_StructureInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Stage_StructureInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_stage_structure(inputs)
	return zh_directory_submit_enrich_stage_structure(inputs)
});
export { directory_submit_enrich_stage_structure as "directory.submit.enrich.stage.structure" }